import React, {useContext} from "react";
import {Button, Col, Form, Row, Stack} from "react-bootstrap";
import {useIntl} from "react-intl";
import messages from "../../../i18n/messages";
import {queryMessageReply} from "../../../utils/MsgUtil";
import {ModalContext} from "../../../contexts/modal/ModalContext";
import {LoadingContext} from "../../../contexts/loading/LoadingContext";

import './MessageReply.css';
import MaxiIcon from "../../Maxiicon/MaxiIcon";

const MessageReply = () => {
    const intl = useIntl();
    const [, setModalContext] = useContext(ModalContext);
    const [, setLoadingContext] = useContext(LoadingContext);
    const [queryCode, setQueryCode] = React.useState('');
    const [msgReply, setMsgReply] = React.useState({
        messageContent: '',
        replies: [],
    });

    async function onQueryClick() {
        if (queryCode.trim().length === 0) {
            // show error message
            setModalContext({
                isShow: true,
                title: intl.formatMessage(messages.errMsgTitle),
                content: intl.formatMessage(messages.errMsgQueryCodeEmptyError),
                onConfirm: () => {},
            });
        } else {
            console.log(queryCode);
            setLoadingContext({
                isLoading: true,
                loadingText: '',
            });
            setMsgReply({
                messageContent: '',
                replies: [],
            })
            try {
                // query message reply
                const response = await queryMessageReply(queryCode);
                if (!response.ok) {
                    setModalContext({
                        isShow: true,
                        title: intl.formatMessage(messages.errMsgTitle),
                        content: intl.formatMessage(messages.errMsgServerError),
                        onConfirm: () => {},
                    });
                } else {
                    const data = await response.json();
                    setMsgReply(data);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setQueryCode('');
                setLoadingContext({
                    isLoading: false,
                    loadingText: '',
                });
            }

        }
    }

    const onPasteClick = () => {
        navigator.clipboard.readText().then(text => {
            setQueryCode(text);
        });
    }

    const onQueryCodeInputChange = (e) => {
        setQueryCode(e.target.value.trim());
    }

    const renderMsgReplies = () => {
        if (msgReply.replies.length === 0) return (<>{intl.formatMessage(messages.currentHasNoReply)}</>);
        return msgReply.replies.map((reply, index) => {
            return (
                <div key={index} className={'message-reply'}>
                    |- <MaxiIcon iconName={'faCommentDots'}/> {reply}
                </div>
            );
        });
    }


    return (
        <>
            <Row>
                <Col>
                    {intl.formatMessage(messages.queryReplyLabel)}
                </Col>
            </Row>
            <br/>
            <Row>
                <Col xs={12} lg={{span: 4, offset: 4}}>
                    <Stack direction="horizontal" gap={1}>
                        <Form.Control
                            className="me-auto"
                            placeholder={intl.formatMessage(messages.queryCodeLabel)}
                            value={queryCode}
                            onChange={onQueryCodeInputChange}
                        />
                        <Button variant="outline-success" onClick={onQueryClick}>
                            {intl.formatMessage(messages.queryButtonLabel)}
                        </Button>
                        <div className="vr" />
                        <Button variant="outline-secondary" onClick={onPasteClick}>
                            {intl.formatMessage(messages.pasteButtonLabel)}
                        </Button>
                    </Stack>
                </Col>
                <Col xs={12} className={'query-code-info'}>
                    {intl.formatMessage(messages.queryCodeInfoText)}
                </Col>
            </Row>
            <br/>
            <Row className={'message-reply-container'}>
                <Col xs={12} lg={{span: 4, offset: 4}} className={'message-content'}>
                    <MaxiIcon iconName={'faComment'} /> {msgReply.messageContent}
                </Col>
                <Col xs={12} lg={{span: 4, offset: 4}}>
                    {renderMsgReplies()}
                </Col>
            </Row>
            <br/>
        </>
    );
}

export default MessageReply;